import { styled } from "@mui/material/styles";

export const GroupHeader = styled("div")(({ theme }) => {
  return {
    position: "sticky",
    top: "-8px",
    padding: theme.spacing(1, 1),
    backgroundColor: theme.palette.background.contentBackground,
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: "0.75rem",
    letterSpacing: "0.5px",
    textTransform: "uppercase" as const,
    zIndex: 10,
  };
});

export const GroupItems = styled("ul")({
  padding: 0,
});

export const SelectedValueContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  position: "absolute",
  left: 14,
  top: "50%",
  transform: "translateY(-50%)",
  pointerEvents: "none",
});

export const SelectedPrimaryText = styled("span")({
  fontSize: "1rem",
  lineHeight: 1.2,
});

export const SelectedSecondaryText = styled("span")(({ theme }) => ({
  fontSize: "0.75rem",
  color: theme.palette.text.secondary,
  lineHeight: 1.2,
}));
